import { render, staticRenderFns } from "./detailCustomer.vue?vue&type=template&id=d033e774&scoped=true&"
import script from "./detailCustomer.vue?vue&type=script&lang=js&"
export * from "./detailCustomer.vue?vue&type=script&lang=js&"
import style0 from "./detailCustomer.vue?vue&type=style&index=0&id=d033e774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d033e774",
  null
  
)

export default component.exports